import http from "../../utils/http";



export const getMailUnsubscribes = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/unsubscribe/list", body)
      .then((res) => {
        resolve(res.data);
      }).catch((err) => {
        reject(err);
      });
  });
};
